import { Box, Select } from '@chakra-ui/react';
import React, { useState } from 'react';

import { PriceFormat } from '@/app/_components/price-format/price-format';
import {
  NewCarData,
  SpecificationsPricesType,
} from '@/types/new-cars/new-cars.types';

import Styles from './variant-select.module.scss';

export const VariantsSelectNewCars: React.FC<{
  variants: SpecificationsPricesType[];
  setSelectedVariant?: any;
  newCar?: NewCarData;
  selectedVariant?: SpecificationsPricesType | null;
  disabled?: boolean;
}> = ({ variants, setSelectedVariant, selectedVariant, disabled = false }) => {
  let price = '0';

  if (selectedVariant?.price) {
    let priceNumberWord = '' + selectedVariant?.price;

    if (parseFloat(selectedVariant?.price) > 3) {
      price = `${priceNumberWord.slice(0, -3)} ${priceNumberWord.slice(-3)}`;
    } else {
      price = priceNumberWord;
    }
  }

  const [variantValue, setVariantValue] = useState(
    selectedVariant ? selectedVariant.title : '',
  );

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    const variantIndex = variants.findIndex((obj) => obj?.title == value);

    const selected = variants[variantIndex];

    setVariantValue(selected?.title || '');
    setSelectedVariant(selected);
  };

  return (
    <>
      <Box className={Styles.customSelect}>
        <Select
          className={Styles.formInput}
          placeholder="Select variant"
          variant="flushed"
          onChange={handleChange}
          disabled={disabled}
          value={variantValue}
          aria-label="select variant"
        >
          {variants?.map((item, index) => (
            <option key={index} value={item.id}>
              {item.title}
            </option>
          ))}
        </Select>
      </Box>

      {selectedVariant && selectedVariant.title.length > 1 && (
        <div className={Styles.variantDetails}>
          <div className={Styles.variantMain}>
            <span className={Styles.variantTitle}></span>

            <span className={Styles.variantPrice}>
              <PriceFormat prefix="R" value={price} />
            </span>
          </div>
        </div>
      )}
    </>
  );
};
